module.exports = __webpack_public_path__ + "img/logo-powered-by-sentinel.38668ac6.svg";